import { Component } from '@angular/core';

@Component({
  selector: 'app-ui-breadcrumb',
  templateUrl: './ui-breadcrumb.component.html',
  styleUrls: ['./ui-breadcrumb.component.css']
})
export class UiBreadcrumbComponent {
  /**
   * Header button list show
   */
  Settingicon = true;
  Menuoption = 'center'
}
